export default {
    /* Global Vocabulary */
    validations: {
        is_required: 'درج «{field_name}» الزامی است.',
        invalid: '«{attribute}» نامعتبر است.',
        this_field_is_required: 'درج این فیلد الزامی است.',
        field_is_copied: '{field} کپی شد!',
    },
    address: 'نشانی',
    of: 'از',
    got_it: 'بسیار خوب',
    attach_file: 'افزودن فایل',
    take_photo: 'عکس بگیرید',
    confirm: 'تأیید',
    ok: 'بسیار خوب',
    copy: 'کپی',
    new: 'جدید',
    site_title: 'ربیت مانی ترانسفر',
    delete: 'حذف',
    edit: 'ویرایش',
    refresh: 'به‌روز رسانی',
    search: 'جستجو',
    total: 'مجموع',
    click_to_confirm: 'برای تأیید کلیک کنید',
    complete: 'کامل',
    currency: 'ارز',
    send: 'ارسال',
    sending: 'در حال ارسال',
    id_document: 'مدرک شناسایی',
    submitting: 'در حال ثبت کردن',
    ideas: 'ایده‌ها',
    update: 'به روز رسانی',
    errors: {
        error_500: 'خطای سرور',
        too_many_requests: 'درخواست‌های بیش از حد.',
        an_error_has_occurred: 'عملیات منجر به خطا شد!',
        something_went_wrong: 'مشکلی پیش آمد!',
        please_try_again_or_contact_rebit_support: 'لطفاً دوباره تلاش کنید یا با پشتیبانی ربیت تماس بگیرید.'
    },
    app: {
        notifications: {
            category_notification_updated: '{category} به روز رسانی شد!',
        },
    },
    please_try_again_another_day: 'لطفاً روز دیگری تلاش کنید.',
    /* Module special vocabulary */
    dashboard: {
        menu: {
            index: 'داشبورد'
        },

        users_count: 'تعداد کاربران',
    },
    content_aware_bar: {
        action_required: 'حساب غیر فعال!',
        verify_now: 'فعالسازی',
        payment_issue: 'مشکل در پرداخت!',
        follow_up: 'پیگیری',
        awaiting_payment_approval: 'در انتظار تأیید پرداخت!',
        pay_now: 'پرداخت',
        resolve_issue: 'بررسی وضعیت'
    },
    feature_dialog: {
        any_ideas_or_suggestions: 'آیا ایده یا پیشنهادی دارید؟',
        got_an_idea_for_a_cool_new_feature: 'برای یک امکان جدید یا بهبود طراحی ربیت، ایده یا راهکاری دارید؟ نظرات خود را با ما در میان بگذارید. به ایده‌های انتخاب شده پاداش تعلق می‌گیرد.',
        let_us_know_how_we_can_improve_rebit: 'چگونه ربیت را بهبود بخشیم.',
        screenshots: 'اسکرین شات‌ها'
    },
    'super-admin': 'مدیر ارشد',
    admin: 'مدیر',
    user: 'کاربر',
    version: 'نسخه',
    roles: {
        'super-admin': 'مدیر ارشد',
        admin: 'مدیر',
        user: 'کاربر',
        assistant: 'دستیار مدیرارشد'
    },
    loading: 'در حال بارگذاری',
    install_dialog: {
        install_rebit_app: 'نصب اپلیکیشن ربیت؟',
        yes: 'بله',
        later: 'بعداً',
        never: 'عدم نمایش',
        install_app_to_access_rebit_from_your_home_screen: 'برنامه را برای دسترسی به ربیت از صفحه اصلی خود نصب کنید.'
    },
    update_required_title: 'نیازمند به روزرسانی',
    update_required_message: 'نسخه‌ی اپلیکیشن شما قدیمی است. لطفاً خارج شده و برای به روزرسانی صفحه را Refresh کنید.',
}

